var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "photo_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#photo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17c-.412 0-.766-.15-1.06-.448A1.452 1.452 0 013 15.5v-11c0-.403.147-.753.44-1.052A1.433 1.433 0 014.5 3h11c.412 0 .766.15 1.06.448.293.299.44.65.44 1.052v11c0 .403-.147.753-.44 1.052A1.433 1.433 0 0115.5 17h-11zm1.75-3h7.504c.15 0 .26-.07.33-.208a.347.347 0 00-.042-.396l-2.25-3a.334.334 0 00-.292-.167.334.334 0 00-.292.167L9.25 13l-1.208-1.604a.334.334 0 00-.292-.167.334.334 0 00-.292.167l-1.496 2a.336.336 0 00-.04.396c.073.139.182.208.328.208z",
    fill: "#fff"
  }))));
}
export default SvgPhoto;